import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const videoApi = createApi({
  reducerPath: "video",
  baseQuery: prepareBaseQuery("/video-links/"),
  tagTypes: ["Video"],
  endpoints: (builder) => ({
    addVideoLink: builder.mutation({
      query: ({ url, description, thumbnailUrl }) => ({
        url: "add-video-link/",
        method: "POST",
        body: { url, description, thumbnailUrl },
      }),
      invalidatesTags: ["Video"],
    }),
    getVideoLink: builder.query({
      query: (videoId) => {
        return {
          url: `get-video-link/${videoId}`,
          method: "GET",
        };
      },
      skip: (videoId) => !videoId,
      providesTags: ["Video"],
    }),
    getAllVideoLinks: builder.query({
      query: () => {
        return {
          url: "get-all-video-links",
          method: "GET",
        };
      },
      providesTags: ["Video"],
    }),
    updateVideoLink: builder.mutation({
      query: ({ videoId, formData }) => {
        return {
          url: `update-video-link/${videoId}`,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: ["Video"],
    }),
    deleteVideoLink: builder.mutation({
      query: ({ videoId }) => ({
        url: `delete-video-link/${videoId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Video"],
    }),
  }),
});

export const {
  useAddVideoLinkMutation,
  useGetAllVideoLinksQuery,
  useGetVideoLinkQuery,
  useUpdateVideoLinkMutation,
  useDeleteVideoLinkMutation,
} = videoApi;

export default videoApi;
export { videoApi };
